import React, { Component, useState } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Modal } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/master/customer-temp/form";
import FormContainerView from "../../../../containers/modules/master/customer-temp/form-view";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import LabelApprove from "../../../utilities/Status/approve-customer";
import LabelApproveCustomerTemp from "../../../utilities/Status/approve-customer-temp";
const MySwal = withReactContent(Swal);

export class TempCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      titleModal: "",
      chose:'1',
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Sales"), class: " text-gray-600" },
        { link: null, title: i18n.t("Customer"), class: " text-gray-500" },
      ],
      column: [
        {
            key: "code",
            filter: { active: true, type: "Text", data: null },
            title: i18n.t("Customer Code"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
            sortable:true

          },
          {
            key: "branch_name",
            filter: { active: true, type: "Text", data: null },
            title: i18n.t("Branch Name"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
          },
        {
          key: "name",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
          sortable:true

        },
        {
            key: "status",
            filter: {
              active: true,
              type: "Select",
              data: [
                  { key: '', label: i18n.t("All") },
                  { key: 1, label: i18n.t("Waiting For Approval") },
                  { key: 0, label: i18n.t("Approved") },
                  { key: 2, label: i18n.t("Rejected") },
              ],
            },
            title: i18n.t("Status"),
            type: "component",
            tHclass: "min-w-125px",
            tdClass: "",
            component:(data,column)=>{
                  return <LabelApproveCustomerTemp value={data[column.key]} />
            }
          },
        {
          key: "createdAt",
          // filter: { active: true, type: "Select", data:null},
          filter: { active: true, type: "Text", data:null},
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
          sortable:true

        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
          sortable:true

        },
        {
          key: "id",
          filter: {
            active: false,
          },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-150px",
          tdClass: "text-center",
          form:'icon',
          buttons: [
            {
              key: "id",
              btnText: i18n.t("View"),
              visible: {
                key: "status",
                key: "status",
                params: [1,2,0],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.viewData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Approve"),
              visible: {
                key: "status",
                params: [1],
                function: (id, params) => {
                  let role=this.props.authUser.userAccess?.role||[]
                  if(params.includes(id) && role.includes('Approval Customer')){
                    return true;
                  }
                  return false;
                },
              },
              btnFunction: (data, column) => {
                this.approveCustomer(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Reject"),
              visible: {
                key: "status",
                params: [1],
                  function: (id, params) => {
                    let role=this.props.authUser.userAccess?.role||[]
                    if(params.includes(id) && role.includes('Approval Customer')){
                      return true;
                    }
                    return false;
                },
              },
              btnFunction: (data, column) => {
                this.rejectData(data);
              },
              bthClass: "btn btn-danger",
            },
          ],
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.viewData = this.viewData.bind(this);
    this.approveCustomer = this.approveCustomer.bind(this);
    this.rejectData = this.rejectData.bind(this);
    this.createData = this.createData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.chose = '1';
    this.state.titleModal = i18n.t("Add Customer");
    this.props.createData();
  }
  updateData(id) {
    this.state.chose = '1';
    this.state.titleModal = i18n.t("Edit Customer");
    this.props.updateItem(id);
  }
  viewData(id) {
    this.state.chose = '2';
    this.state.titleModal = i18n.t("Customer");
    this.props.viewItem(id);
  }
  approveCustomer(id) {
    //this.props.approveItem(id);
    const html = (
      <>
        <div>{i18n.t("You will Approve this Customer")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="success"
          onClick={() => {
           this.props.approveItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Approve Customer"),
              html: i18n.t("Please Wait ...."),
              icon: "info",
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Accept")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  
  rejectData(id) {
    const html = (
      <>
        <div>{i18n.t('You will reject this Customer')}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t('Cancel')}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.rejectItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Rejecting Data"),
              html: i18n.t("Please Wait ...."),
              icon: "info",
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Accept")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }

  filterAt(){
    const {data}= this.props
  }

  render() {
    const { isProcessing, data, showModal } = this.props;
    this.state.listData = data;
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-primary m-1"
                      onClick={(e) => this.createData()}
                    >
                      {i18n.t("Add Customer")}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <Table
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  rejectData={this.rejectData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        {(this.state.chose == '1')?
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
        :
        <FormContainerView
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
        }
      </div>
    );
  }
}

export default TempCustomer;
